import { P } from 'components'
import { ArrowLeft } from 'react-feather'
import { Modal, ModalBody, ModalHeader } from 'reactstrap'

const PMBModalTraceability = ({ isOpen, toggle, productId }) => {
  return (
    <Modal isOpen={isOpen} toggle={toggle} fullscreen keyboard={false} data-testid="pmb-modal-traceability">
      <div
        className="d-flex align-items-center gap-2 p-3"
        style={{ borderBottom: '1px solid #ededed' }}
      >
        <ArrowLeft
          style={{ cursor: 'pointer' }}
          onClick={toggle}
          data-testid="pmb-modal-traceability-back"
        />
        <P className="align-middle" bold>
          Traceability
        </P>
      </div>
      <ModalBody
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          maxHeight: '100vh',
          overflowY: 'auto',
          padding: 0,
        }}
      >
        <iframe
          src={`${process.env.REACT_APP_INVENTORY_URL}?productId=${productId}`}
          title="Traceability"
          data-testid="pmb-modal-traceability-iframe"
          style={{
            marginTop: '62px',
            width: '100%',
            height: '100vh',
            border: 'none',
          }}
        />
      </ModalBody>
    </Modal>
  )
}

export default PMBModalTraceability
